import { useMemo } from 'react';
import { redirect, useLocation, } from 'react-router-dom';
import { ApplicationMetricsContextStates, setContextState, } from '../application-metrics-context/application-metrics-context-service';
export var AppModule;
(function (AppModule) {
    AppModule["Insights"] = "insights";
    AppModule["Data"] = "data";
    AppModule["Develop"] = "develop";
    AppModule["Admin"] = "admin";
    AppModule["OnBoarding"] = "onboarding";
})(AppModule || (AppModule = {}));
export const parsePrivilegedRouteMap = (privilegedRouteMap) => {
    return Object.entries(privilegedRouteMap).map(parsePrivilegedRoute);
};
const parsePrivilegedRoute = ([routeID, privilegedRoute,]) => {
    const { privileges, fallback, loader, children, pageContext, title, handle, customRouteData, ...others } = privilegedRoute;
    return {
        id: routeID,
        ...others,
        children: children && parsePrivilegedRouteMap(children),
        loader: async (options) => {
            var _a;
            setContextState(pageContext || ApplicationMetricsContextStates.DEFAULT_PAGE);
            if (privileges) {
                try {
                    await Promise.all((_a = Object.values(privileges)) !== null && _a !== void 0 ? _a : []);
                }
                catch (error) {
                    if (typeof fallback === 'function')
                        fallback(error, options);
                    else
                        throw redirect(fallback || '/');
                }
            }
            if (loader) {
                const loaderReturn = await loader(options);
                return loaderReturn !== null && loaderReturn !== void 0 ? loaderReturn : null;
            }
            return null;
        },
        handle: {
            handle,
            title,
            customRouteData,
        },
    };
};
const getRouteRegexes = (routeMap) => {
    if (!routeMap) {
        return {};
    }
    return Object.entries(routeMap).reduce((localizedRoutes, [routeID, route]) => {
        const routePathArr = route.path.split('/');
        const regexedPathArr = routePathArr.map((segment) => {
            if (segment.startsWith(':') ||
                segment.endsWith('?') ||
                segment.includes('*')) {
                return '.*';
            }
            return segment;
        });
        return {
            ...localizedRoutes,
            [routeID]: regexedPathArr.join('/'),
            ...getRouteRegexes(route.children),
        };
    }, {});
};
export const useMatchLocalRouteMap = (routeMap) => {
    const { pathname } = useLocation();
    const memoizedRouteMap = useMemo(() => getRouteRegexes(routeMap), [
        routeMap,
    ]);
    return Object.entries(routeMap).reduce((matchedRoutes, [routeID, route]) => {
        if (pathname.match(memoizedRouteMap[routeID])) {
            return [...matchedRoutes, route];
        }
        return matchedRoutes;
    }, []);
};
//# sourceMappingURL=routing.util.js.map